/**
 * 2026-10-20 lotus 기준 공통 반영 (lavis #5524): 내가 등록한 피드백이 개발에 반영되면 런처 위에 작은 '반영됨' 표시.
 * 비로그인 등록도 있으므로 등록 id 를 이 브라우저에 보관 → 서버엔 id 만 보내 반영 완료 id 만 받음.
 * 표시를 누르면 확인 처리(acked) → 같은 피드백으로는 다시 안 뜸.
 */
import { fetchReflectedIds } from './api';

const MINE_KEY = 'dev-feedback-mine';
const ACKED_KEY = 'dev-feedback-reflected-acked';
const MAX_IDS = 50;

const readIds = (key: string): number[] => {
  try {
    const parsed = JSON.parse(localStorage.getItem(key) || '[]');
    return Array.isArray(parsed) ? parsed.filter((v): v is number => Number.isInteger(v) && v > 0) : [];
  } catch {
    return [];
  }
};

const writeIds = (key: string, ids: number[]): void => {
  try {
    localStorage.setItem(key, JSON.stringify(ids.slice(-MAX_IDS)));
  } catch {
    /* ignore */
  }
};

/** 등록 성공 시 호출 */
export const rememberMyFeedback = (id: number): void => {
  if (!Number.isInteger(id) || id <= 0) return;
  writeIds(MINE_KEY, [...readIds(MINE_KEY).filter((v) => v !== id), id]);
};

/** 아직 확인 안 한 반영 완료 id */
export const loadUnackedReflected = async (): Promise<number[]> => {
  const acked = new Set(readIds(ACKED_KEY));
  const pending = readIds(MINE_KEY).filter((id) => !acked.has(id));
  if (pending.length === 0) return [];
  const reflected = await fetchReflectedIds(pending);
  return reflected.filter((id) => !acked.has(id));
};

/** 표시 클릭 → 확인 처리. 확인한 id 는 내 목록에서도 빼서 다시 조회하지 않음 */
export const ackReflected = (ids: number[]): void => {
  if (ids.length === 0) return;
  const done = new Set(ids);
  writeIds(ACKED_KEY, [...readIds(ACKED_KEY).filter((v) => !done.has(v)), ...ids]);
  writeIds(MINE_KEY, readIds(MINE_KEY).filter((v) => !done.has(v)));
};
